import React from "react";
import { Link } from "react-router-dom";
import '../Styles/JuniorLandingPage.scss';
function JuniorLandingPage() {
   return (
      <div>
         <div className="juniorLandingPageContent">
            <div className="juniorLandingPageContainer">
               <div className="juniorLandingPageTitleContainer">
                  <div className="juniorLandingPageTitle">
                     Junior Camps
                  </div>
               </div>
               <div className="juniorLandingPageDescription">
                     Junior Camps give elementary-aged children <br></br>
                     exciting summer activities and share the <br></br>
                     gospel that changes lives. There are two <br></br>
                     exciting camps to choose from<br></br>
               </div>
               <div className="juniorLandingPageCamps">
                     <div className="juniorOvernightCamp">
                        <div className="juniorOvernightCampTitle">
                           Junior Overnight Camp
                        </div>
                        <div className="juniorOvernightCampContent">
                           Junior Overnight Camps are a <br></br>
                           week of exciting activities.<br></br>
                           Campers stay overnight in cabins.
                        </div>
                        <div className="juniorOvernightCampButton">
                        <Link to={"/juniors"}><button>Learn More</button></Link>
                        </div>
                     </div>

                  <div className="juniorDayCamp">
                     <div className="juniorDayCampTitle">
                        Junior Day Camp
                     </div>
                     <div className="juniorDayCampContent">
                     Junior Day Camps are daily camps held throughout the summer for local boys and girls.<br></br> 
                           Campers arrive each morning and are picked up in the afternoon.
                     </div>
                     <div className="juniorDayCampButton">
                        <Link to={"/juniorsdaycamp"}><button>Learn More</button></Link>
                     </div>
                  </div>

               </div>

            </div>
         </div>
      </div>
   )
}
export default JuniorLandingPage;
